export function FeaturedListings() {
  const listings = [
    {
      image: 'https://hurley-associates.com/web/images/slides/140-002.jpg',
      title: 'Luxury Gulf Front Property',
      location: 'St. Pete Beach, FL',
      type: 'For Sale'
    },
    {
      image: 'https://hurley-associates.com/images/random/023-001.jpg',
      title: 'Modern Beach House',
      location: 'Pass-a-Grille, FL',
      type: 'For Sale'
    },
    {
      image: 'https://hurley-associates.com/images/random/004-001.jpg',
      title: 'Waterfront Condo',
      location: 'St. Pete Beach, FL',
      type: 'For Rent'
    },
    {
      image: 'https://hurley-associates.com/images/random/029-001.jpg',
      title: 'Beachside Villa',
      location: 'Gulf Beach Area, FL',
      type: 'For Sale'
    }
  ];

  return (
    <section id="listings" className="py-24 bg-gradient-to-br from-gray-50 to-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Featured Listings
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover exceptional properties in the St. Pete Beach area
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {listings.map((listing, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img 
                  src={listing.image}
                  alt={listing.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-teal-600 text-white px-4 py-1.5 rounded-full text-xs font-semibold">
                  {listing.type}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2">{listing.title}</h3>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-map-pin-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                  <span>{listing.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-gray-900 text-white px-8 py-4 rounded-full text-sm font-semibold hover:bg-gray-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
            View All Listings
          </button>
        </div>
      </div>
    </section>
  );
}